/* Desayunos del Cielo · Catálogo deslizable v3
   - Paginador propio con física tipo Instagram/Reels: sigue el dedo, decide por distancia o velocidad
     del gesto y asienta con una curva suave. Rueda, teclado y enlaces #producto también funcionan.
   - Dos botones a la derecha: "Lo quiero" (agrega directo) y "Mi pedido".
   - Recuerda dónde ibas y tu pedido (localStorage, 3 días).
   - Pedido: 1) entrega → 2) hazlo más especial + WhatsApp o pagar en internet → 3) quién recibe → checkout de Shopify. */
(function () {
  var root = document.querySelector('[data-ddc-cs]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var html = document.documentElement;
  html.classList.add('ddc-cs-page');

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var money = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); };
  var gtag = function () { if (typeof window.gtag === 'function') window.gtag.apply(null, arguments); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var phone = root.dataset.phone || '573508603080';
  var cutoff = parseInt(root.dataset.cutoff, 10) || 17;
  var KEY = 'ddc_cs_v3';
  var CAT = (root.dataset.cat || location.pathname + (new URLSearchParams(location.search).get('view') || ''));
  var TTL = 3 * 24 * 3600 * 1000;

  var products = {};
  $$('[data-ddc-cs-product]').forEach(function (s) { try { var p = JSON.parse(s.textContent); products[p.slug] = p; } catch (e) {} });

  /* ---------- estado + memoria ---------- */
  var state = { items: [], addons: [], day: null, date: null, slot: null, zone: null, address: '', to: '', tophone: '', msg: '', anon: false, from: '', fromphone: '', email: '', notes: '', occasion: '', sign: '', colors: [], slide: 0, step: 0, ts: 0 };
  var restored = false;
  try {
    var saved = JSON.parse(localStorage.getItem(KEY));
    if (saved && Date.now() - (saved.ts || 0) < TTL) { state = Object.assign(state, saved); restored = true; }
  } catch (e) {}
  function save() { state.ts = Date.now(); try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  /* ---------- feed con desplazamiento nativo (como Instagram/TikTok web) ----------
     El contenedor hace scroll con la inercia propia del celular y se acomoda en cada página (scroll-snap).
     Los botones se esconden mientras se desliza y vuelven cuando la página queda quieta. */
  var feed = $('[data-ddc-cs-feed]');
  var slides = $$('[data-ddc-cs-slide]');
  var chips = $$('[data-ddc-cs-chip]');
  var rail = $('[data-ddc-cs-rail]');
  var want = $('[data-ddc-cs-want]');
  var index = 0, current = null, firstView = true;
  var ticks = $$('[data-ddc-cs-tick]');
  var firstLoad = true;
  var zoomBtn = $('[data-ddc-cs-zoomopen]');
  var sheetOpen = function () { return !sheet.hidden; };

  function measure() { root.style.setProperty('--cs-h', window.innerHeight + 'px'); }
  // Carga diferida real: las páginas guardan su imagen en data-* y solo la reciben cuando les toca.
  function eager(i) {
    var s = slides[i]; if (!s) return;
    s.querySelectorAll('[data-srcset],[data-src]').forEach(function (el) {
      if (el.dataset.srcset) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); }
      if (el.dataset.src) { el.src = el.dataset.src; el.removeAttribute('data-src'); }
    });
    var img = s.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager';
  }
  function go(i, animate) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    feed.scrollTo({ top: slides[i].offsetTop, behavior: animate === false ? 'auto' : 'smooth' });
  }
  function setIndex(i) {
    if (!slides[i]) return;
    if (i === index && !firstView) return;
    var changed = i !== index || firstView;
    firstView = false;
    index = i;
    eager(i);
    var curImg = slides[i].querySelector('.ddc-cs__page img');
    var loadNeighbors = function () {
      var run = function () { eager(i + 1); if (!firstLoad) { eager(i + 2); eager(i - 1); } firstLoad = false; };
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1500 }); else setTimeout(run, 400);
    };
    if (!curImg || (curImg.complete && curImg.naturalWidth)) loadNeighbors();
    else curImg.addEventListener('load', loadNeighbors, { once: true });
    var s = slides[index];
    var slug = s.dataset.slug || null;
    current = slug;
    rail.classList.toggle('is-product', !!slug);
    want.hidden = !slug;
    zoomBtn.hidden = !slug;
    want.classList.toggle('is-wa', !!(slug && products[slug] && products[slug].waOnly));
    var passed = true;
    ticks.forEach(function (t) {
      var on = t.dataset.ddcCsTick === slug;
      t.classList.toggle('is-on', on);
      t.classList.toggle('is-done', passed && !on && !!slug);
      if (on) passed = false;
    });
    if (!slug) ticks.forEach(function (t) { t.classList.toggle('is-done', index > 0); });
    chips.forEach(function (c) {
      var on = c.dataset.ddcCsChip === slug;
      c.classList.toggle('is-on', on);
      if (on) c.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    });
    state.slides = state.slides || {}; state.slides[CAT] = index; save();
    if (slug) {
      history.replaceState(history.state, '', '#' + slug);
      if (changed) gtag('event', 'view_item', { currency: 'COP', value: products[slug].price / 100, item_list_name: 'catalogo_deslizable', items: [{ item_id: products[slug].handle, item_name: products[slug].title }] });
    }
    wake();
  }
  // ¿qué página está en pantalla? (la que ocupa más del 60 %)
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setIndex(slides.indexOf(e.target)); });
  }, { root: feed, threshold: [0.6] });
  slides.forEach(function (s) { io.observe(s); });

  // botones: se esconden al deslizar, vuelven al quedar quieto
  var still;
  function moving() {
    root.classList.add('is-moving');
    clearTimeout(still);
    still = setTimeout(settled, 160);
  }
  function settled() { root.classList.remove('is-moving'); }
  feed.addEventListener('scroll', moving, { passive: true });
  if ('onscrollend' in window) feed.addEventListener('scrollend', function () { clearTimeout(still); settled(); });

  document.addEventListener('keydown', function (e) {
    if (sheetOpen()) { if (e.key === 'Escape') closeSheet(); return; }
    if (['ArrowDown', 'PageDown', ' '].indexOf(e.key) >= 0) { e.preventDefault(); go(index + 1); }
    if (['ArrowUp', 'PageUp'].indexOf(e.key) >= 0) { e.preventDefault(); go(index - 1); }
  });
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    e.preventDefault();
    var id = a.getAttribute('href').slice(1);
    for (var i = 0; i < slides.length; i++) if (slides[i].id === id) { go(i); break; }
  });
  function idOf(id) { for (var i = 0; i < slides.length; i++) if (slides[i].id === id) return i; return -1; }
  window.addEventListener('resize', measure);

  var bar = $('.ddc-cs__bar'), idle;
  function wake() { bar.classList.remove('is-idle'); clearTimeout(idle); idle = setTimeout(function () { bar.classList.add('is-idle'); }, 2400); }
  bar.addEventListener('pointerdown', wake);

  /* ---------- Lo quiero ----------
     Página de 1 producto: agrega directo.
     Página de 2 productos: abre "¿Cuál quieres?" (también al tocar la foto, con el de esa mitad resaltado). */
  function addProduct(p) {
    if (!p.available) { toast('Este producto no está disponible ahora'); return false; }
    var line = state.items.filter(function (i) { return i.slug === p.slug; })[0];
    if (line) line.qty += 1;
    else state.items.push({ slug: p.slug, title: p.title, handle: p.handle, variantId: p.variantId, price: p.price, qty: 1 });
    save(); renderCount();
    want.classList.remove('is-pop'); void want.offsetWidth; want.classList.add('is-pop');
    gtag('event', 'add_to_cart', { currency: 'COP', value: p.price / 100, item_list_name: 'catalogo_deslizable', items: [{ item_id: p.handle, item_name: p.title, price: p.price / 100, quantity: 1 }] });
    return true;
  }
  function qtyOf(slug) { var l = state.items.filter(function (i) { return i.slug === slug; })[0]; return l ? l.qty : 0; }

  var pick = $('[data-ddc-cs-pick]'), pickList = $('[data-ddc-cs-picklist]');
  function renderPick(page, focus) {
    var opts = [page, page.second];
    pickList.innerHTML = '';
    opts.forEach(function (p, i) {
      var q = qtyOf(p.slug);
      var li = document.createElement('li');
      li.className = 'ddc-cs__pickrow' + (focus === i ? ' is-focus' : '') + (q ? ' is-in' : '');
      li.innerHTML = (p.image ? '<img src="' + esc(p.image) + '" alt="" width="56" height="56">' : '<span class="ddc-cs__pickph"></span>') +
        '<span class="ddc-cs__pickname"><strong>' + esc(p.title) + '</strong><small>' + money(p.price) + (q ? ' · en tu pedido: ' + q : '') + '</small></span>' +
        '<button type="button" class="ddc-cs__pickadd" data-i="' + i + '" aria-label="Agregar ' + esc(p.title) + '">' + (q ? '✓' : '+') + '</button>';
      pickList.appendChild(li);
    });
    pickList.onclick = function (e) {
      var row = e.target.closest('.ddc-cs__pickrow'); if (!row) return;
      var i = +row.querySelector('[data-i]').dataset.i;
      if (addProduct(opts[i])) { renderPick(page, i); toast('✓ ' + opts[i].title.replace(/^Desayuno /, '') + ' agregado', 'Ver pedido'); }
    };
  }
  function openPick(page, focus) {
    hideToast();
    renderPick(page, focus);
    pick.hidden = false;
    requestAnimationFrame(function () { pick.classList.add('is-open'); });
    var f = pickList.querySelector('.is-focus .ddc-cs__pickadd') || pickList.querySelector('.ddc-cs__pickadd');
    if (f) f.focus({ preventScroll: true });
    gtag('event', 'ddc_catalogo_pick_open', { pagina: page.slug });
  }
  function closePick() { pick.classList.remove('is-open'); setTimeout(function () { pick.hidden = true; }, 220); }
  $$('[data-ddc-cs-pickclose]', pick).forEach(function (b) { b.addEventListener('click', closePick); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pick.hidden) closePick(); });

  want.addEventListener('click', function () {
    var p = products[current];
    if (!p) return;
    if (p.waOnly) {
      gtag('event', 'whatsapp_click', { wa_button: 'catalogo_solo_whatsapp', producto: p.title });
      window.open('https://wa.me/' + phone + '?text=' + encodeURIComponent('¡Hola! Vi en el catálogo web el ' + p.title + ' y lo quiero. ¿Me ayudan con el precio y la entrega?'), '_blank', 'noopener');
      return;
    }
    if (p.second) { openPick(p, null); return; }
    if (addProduct(p)) toast('✓ Agregado', 'Ver pedido');
  });
  // tocar la foto de una página doble: abre el selector con el producto de esa mitad
  slides.forEach(function (sl) {
    var p = products[sl.dataset.slug];
    if (!p || !p.second) return;
    sl.classList.add('is-double');
    var fig = sl.querySelector('.ddc-cs__page');
    fig.addEventListener('click', function (e) {
      var img = fig.querySelector('img'), r = img.getBoundingClientRect();
      var first = p.layout === 'lado-lado' ? (e.clientX - r.left) < r.width / 2 : (e.clientY - r.top) < r.height / 2;
      openPick(p, first ? 0 : 1);
    });
  });

  function count() { return state.items.reduce(function (t, i) { return t + i.qty; }, 0); }
  function renderCount() { var n = count(), el = $('[data-ddc-cs-count]'); el.textContent = n; el.hidden = !n; }

  /* ---------- hoja del pedido ---------- */
  var sheet = $('[data-ddc-cs-sheet="checkout"]');
  var lastFocus = null;
  function openSheet(step) {
    lastFocus = document.activeElement;
    hideToast();
    showStep(step || 1); renderAll();
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    html.classList.add('ddc-cs-lock');
    $('.ddc-cs__x', sheet).focus({ preventScroll: true });
    gtag('event', 'begin_checkout', { currency: 'COP', value: itemsTotal() / 100, checkout_type: 'catalogo_deslizable' });
  }
  function closeSheet() {
    sheet.classList.remove('is-open');
    setTimeout(function () { sheet.hidden = true; }, 260);
    html.classList.remove('ddc-cs-lock');
    state.step = 0; save();
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-ddc-cs-checkout]')) openSheet(); });
  $$('[data-ddc-cs-close]', sheet).forEach(function (b) { b.addEventListener('click', closeSheet); });
  function showStep(n) {
    $$('[data-ddc-cs-step]', sheet).forEach(function (s) { s.hidden = s.dataset.ddcCsStep !== String(n); });
    $('.ddc-cs__panel', sheet).scrollTop = 0;
    state.step = n; save();
  }

  var linesEl = $('[data-ddc-cs-lines]');
  function renderLines() {
    linesEl.innerHTML = '';
    state.items.forEach(function (it, i) {
      var li = document.createElement('li');
      li.innerHTML = '<strong>' + esc(it.title) + '</strong>' +
        '<span class="ddc-cs__qty"><button type="button" data-q="-1" data-i="' + i + '" aria-label="Quitar uno">−</button><b>' + it.qty + '</b><button type="button" data-q="1" data-i="' + i + '" aria-label="Agregar uno">+</button></span>' +
        '<span class="ddc-cs__lp">' + money(it.price * it.qty) + '</span>';
      linesEl.appendChild(li);
    });
    $('[data-ddc-cs-empty]').hidden = !!state.items.length;
    $('[data-ddc-cs-delivery]').hidden = !state.items.length;
    $('[data-ddc-cs-next]').hidden = !state.items.length;
  }
  linesEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    var it = state.items[+b.dataset.i]; it.qty += +b.dataset.q;
    if (it.qty <= 0) state.items.splice(+b.dataset.i, 1);
    save(); renderCount(); renderAll();
  });

  /* fecha */
  function bogotaNow() {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false });
    var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, hour: parseInt(p.hour, 10) % 24 };
  }
  function addDays(iso, n) { var d = new Date(iso + 'T12:00:00'); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); }
  var now = bogotaNow(), today = now.date, tomorrow = addDays(today, 1);
  // una fecha guardada que ya pasó no sirve
  if (state.date && state.date < today) { state.date = null; state.day = null; state.slot = null; }
  if (state.date) state.day = state.date === today ? 'hoy' : state.date === tomorrow ? 'manana' : 'otra';
  var dateInput = $('[data-ddc-cs-date]');
  dateInput.min = today;
  function bonita(iso) { return new Date(iso + 'T12:00:00').toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' }); }

  $$('[data-ddc-cs-days] [data-day]').forEach(function (b) {
    b.addEventListener('click', function () { state.day = b.dataset.day; state.date = state.day === 'hoy' ? today : tomorrow; save(); renderAll(); });
  });
  dateInput.addEventListener('change', function () {
    if (!dateInput.value) return;
    state.date = dateInput.value < today ? today : dateInput.value;
    state.day = state.date === today ? 'hoy' : state.date === tomorrow ? 'manana' : 'otra';
    save(); renderAll();
  });
  // franjas (aparecen en el paso 1 y en el 3)
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slot]'); if (!b || b.disabled) return;
    state.slot = state.slot === b.dataset.slot ? null : b.dataset.slot; save(); renderAll();
  });
  $$('[data-ddc-cs-zones] [data-zone]').forEach(function (b) {
    b.addEventListener('click', function () { state.zone = b.dataset.zone; save(); renderAll(); });
  });
  // campos de texto (dirección del paso 1 y 3 son el mismo dato)
  var addr = $('[data-ddc-cs-address]');
  addr.addEventListener('input', function () { state.address = addr.value; save(); });
  $$('[data-ddc-cs-f]').forEach(function (el) {
    var k = el.dataset.ddcCsF;
    el.addEventListener(el.type === 'checkbox' || el.tagName === 'SELECT' ? 'change' : 'input', function () {
      if (k === 'address3') state.address = el.value;
      else state[k] = el.type === 'checkbox' ? el.checked : el.value;
      if (el.getAttribute('aria-invalid') === 'true' && fieldOk(el)) el.removeAttribute('aria-invalid');
      if (k === 'anon') renderSign();
      if (k === 'msg') renderMsgCount();
      save();
    });
  });
  // colores de decoración (opcional, como en la página de producto)
  var maxColors = parseInt(root.dataset.maxColors, 10) || 2;
  $$('[data-ddc-cs-colors] [data-color]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!Array.isArray(state.colors)) state.colors = [];
      var c = b.dataset.color, i = state.colors.indexOf(c);
      if (i >= 0) state.colors.splice(i, 1);
      else if (state.colors.length < maxColors) state.colors.push(c);
      else { state.colors.shift(); state.colors.push(c); }
      save(); renderColors();
    });
  });
  function renderColors() {
    var cs = Array.isArray(state.colors) ? state.colors : [];
    $$('[data-ddc-cs-colors] [data-color]').forEach(function (b) { var on = cs.indexOf(b.dataset.color) >= 0; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    var n = $('[data-ddc-cs-colornote]');
    if (n) n.textContent = cs.length ? 'Elegiste: ' + cs.join(' y ') : 'Si no eliges, te escribimos para confirmarlos.';
  }
  function renderSign() {
    var s = $('[data-ddc-cs-f="sign"]'); if (!s) return;
    s.disabled = !!state.anon; s.closest('.ddc-cs__field').classList.toggle('is-anon', !!state.anon);
  }
  function renderMsgCount() {
    var c = $('[data-ddc-cs-msgcount]'); if (c) c.textContent = String((state.msg || '').length) + '/500';
  }
  function fieldOk(el) {
    var v = String(el.value || '').trim(), k = el.dataset.kind;
    if (!k) return true;
    if (k === 'phone') { var d = v.replace(/\D/g, ''); return /^[+()\-\s\d]+$/.test(v) && d.length >= 10 && d.length <= 15; }
    if (k === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    if (k === 'address') return v.length >= 6;
    return v.length >= 2;
  }

  $$('[data-addon]').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = +b.dataset.addon, i = state.addons.indexOf(id);
      if (i >= 0) state.addons.splice(i, 1); else state.addons.push(id);
      save(); renderAll();
    });
  });

  function zoneBtn() { return state.zone ? $('[data-ddc-cs-zones] [data-zone="' + state.zone + '"]') : null; }
  function slotBtn() { return state.slot ? $('[data-slot="' + state.slot + '"]') : null; }
  function itemsTotal() { return state.items.reduce(function (t, i) { return t + i.price * i.qty; }, 0); }
  function addonsTotal() { return state.addons.reduce(function (t, id) { var b = $('[data-addon="' + id + '"]'); return t + (b ? +b.dataset.price : 0); }, 0); }
  function shipping() { var z = zoneBtn(); return z ? +z.dataset.price : 0; }
  function specialFee() { var s = slotBtn(); return s && s.dataset.special ? +s.dataset.price : 0; }
  function total() { return itemsTotal() + addonsTotal() + shipping() + specialFee(); }

  function renderAll() {
    renderLines();
    if (state.items.length && state.date && state.zone) $('[data-ddc-cs-err1]').hidden = true;
    $$('[data-ddc-cs-days] [data-day]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.day === state.day); });
    var dl = $('[data-ddc-cs-datelbl]');
    dl.textContent = state.day === 'otra' && state.date ? bonita(state.date) : 'Otra fecha';
    dl.parentNode.classList.toggle('is-on', state.day === 'otra');
    var note = $('[data-ddc-cs-daynote]');
    var lateTomorrow = now.hour >= cutoff && state.date === tomorrow;
    if (state.day === 'hoy') { note.hidden = false; note.textContent = 'Para hoy te confirmamos disponibilidad por WhatsApp.'; }
    else if (lateTomorrow) { note.hidden = false; note.textContent = 'Después de las 5:00 p. m., para mañana queda la franja de 10 a. m. a 12 m.'; }
    else { note.hidden = false; note.textContent = '\u00a0'; }
    $$('[data-slot]').forEach(function (b) {
      var off = lateTomorrow && parseFloat(b.dataset.start) < 10;
      b.disabled = off; b.classList.toggle('is-soldout', off);
      if (off && state.slot === b.dataset.slot) state.slot = null;
      b.classList.toggle('is-on', state.slot === b.dataset.slot);
    });
    $$('[data-ddc-cs-zones] [data-zone]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.zone === state.zone); });
    if (document.activeElement !== addr) addr.value = state.address || '';
    $$('[data-ddc-cs-f]').forEach(function (el) {
      if (el === document.activeElement) return;
      var k = el.dataset.ddcCsF;
      if (el.type === 'checkbox') el.checked = !!state.anon;
      else if (el.tagName === 'SELECT') { if (state[k]) el.value = state[k]; else state[k] = el.value; }
      else el.value = (k === 'address3' ? state.address : state[k]) || '';
    });
    renderColors(); renderSign(); renderMsgCount();
    var sd = $('[data-ddc-cs-sumdate]'); if (sd) sd.textContent = state.date ? bonita(state.date) : '';
    $$('[data-addon]').forEach(function (b) { var on = state.addons.indexOf(+b.dataset.addon) >= 0; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    $('[data-ddc-cs-t1]').textContent = money(itemsTotal() + shipping() + specialFee());
    $('[data-ddc-cs-tprod]').textContent = money(itemsTotal());
    $('[data-ddc-cs-taddrow]').hidden = !addonsTotal();
    $('[data-ddc-cs-tadd]').textContent = money(addonsTotal());
    $('[data-ddc-cs-tship]').textContent = state.zone ? money(shipping()) : 'Elige la zona';
    $('[data-ddc-cs-tspecialrow]').hidden = !specialFee();
    $('[data-ddc-cs-tspecial]').textContent = money(specialFee());
    $('[data-ddc-cs-tall]').textContent = money(total());
    $('[data-ddc-cs-t3]').textContent = money(total());
    var isToday = state.day === 'hoy';
    $('[data-ddc-cs-topay]').hidden = isToday;
    $('[data-ddc-cs-paynote]').hidden = !isToday;
  }

  $('[data-ddc-cs-next]').addEventListener('click', function () {
    var err = $('[data-ddc-cs-err1]');
    var msg = !state.items.length ? 'Agrega al menos un producto.' : !state.date ? 'Elige para cuándo: hoy, mañana u otra fecha.' : !state.zone ? 'Elige la zona de entrega.' : '';
    err.hidden = !msg; err.textContent = msg;
    if (msg) return;
    showStep(2); renderAll();
  });
  $('[data-ddc-cs-back]').addEventListener('click', function () { showStep(1); });
  $('[data-ddc-cs-back2]').addEventListener('click', function () { showStep(2); });
  $('[data-ddc-cs-topay]').addEventListener('click', function () {
    showStep(3); renderAll();
    gtag('event', 'add_shipping_info', { currency: 'COP', value: total() / 100, checkout_type: 'catalogo_deslizable' });
  });

  /* ---------- WhatsApp ---------- */
  $('[data-ddc-cs-wa]').addEventListener('click', function () {
    var z = zoneBtn();
    var L = ['¡Hola! Quiero este pedido del catálogo web:', ''];
    state.items.forEach(function (it) { L.push('• ' + (it.qty > 1 ? it.qty + ' × ' : '') + it.title + ' — ' + money(it.price * it.qty)); });
    state.addons.forEach(function (id) { var b = $('[data-addon="' + id + '"]'); if (b) L.push('+ ' + b.dataset.title + ' — ' + money(+b.dataset.price)); });
    L.push('');
    L.push('Entrega: ' + (state.day === 'hoy' ? 'HOY (' + bonita(state.date) + ')' : bonita(state.date)) + (state.slot ? ', ' + state.slot : ''));
    L.push('Zona: ' + z.dataset.name + ' (domicilio ' + money(shipping()) + ')');
    if (state.address) L.push('Dirección: ' + state.address);
    if (specialFee()) L.push('Horario especial: ' + money(specialFee()));
    L.push('Total: ' + money(total()));
    L.push('');
    L.push('Quiero continuar el pago por aquí. ¿Me ayudan a confirmar colores y tarjeta?');
    gtag('event', 'whatsapp_click', { wa_button: 'catalogo_deslizable', value: total() / 100, currency: 'COP' });
    gtag('event', 'generate_lead', { method: 'catalogo_deslizable_whatsapp', value: total() / 100, currency: 'COP' });
    window.open('https://wa.me/' + phone + '?text=' + encodeURIComponent(L.join('\n')), '_blank', 'noopener');
  });

  /* ---------- Pagar en internet: carrito de Shopify con todo + checkout prellenado ---------- */
  function splitName(raw) {
    var w = String(raw || '').trim().split(/\s+/).filter(Boolean);
    if (!w.length) return ['', ''];
    return w.length === 1 ? [w[0], '-'] : [w[0], w.slice(1).join(' ')];
  }
  $('[data-ddc-cs-pay]').addEventListener('click', async function () {
    var err = $('[data-ddc-cs-cerr]');
    var first = null;
    $$('[data-ddc-cs-step="3"] [data-kind]').forEach(function (el) {
      var ok = fieldOk(el);
      if (ok) el.removeAttribute('aria-invalid'); else { el.setAttribute('aria-invalid', 'true'); if (!first) first = el; }
    });
    var msg = first ? 'Completa los datos marcados: nombre, WhatsApp, correo y dirección.' : !state.slot ? 'Elige la hora de entrega.' : '';
    err.hidden = !msg; err.textContent = msg;
    if (first) { first.focus({ preventScroll: true }); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    else if (msg) { var sw = $('[data-ddc-cs-slotwrap]'); if (sw) sw.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    if (msg) return;
    var btn = this, label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Preparando el pago…';
    try {
      var z = zoneBtn(), s = slotBtn(), pedido = 'CAT-' + Date.now().toString(36).toUpperCase();
      var base = {
        'Fecha de entrega': state.date, 'Franja de entrega': state.slot, 'Zona de entrega': z.dataset.name,
        'Dirección de entrega': state.address.trim(), 'Quién recibe': state.to.trim(), 'Teléfono de quien recibe': state.tophone.trim(),
        'Quién envía': state.from.trim(), 'Teléfono de quien envía': state.fromphone.trim(), '_Correo de quien envía': state.email.trim(),
        'Colores': (state.colors && state.colors.length) ? state.colors.join(', ') : 'Por confirmar por WhatsApp',
        _ddc_pedido: pedido, _origen: 'catalogo_deslizable'
      };
      if (state.notes.trim()) base['Indicaciones de entrega'] = state.notes.trim();
      if (state.occasion) base['Ocasión'] = state.occasion;
      if (state.msg.trim()) base['Mensaje de la tarjeta'] = state.msg.trim();
      if (state.anon) { base['Anónimo'] = 'Sí'; base['Firma de la tarjeta'] = 'Anónimo'; }
      else if (state.sign.trim()) base['Firma de la tarjeta'] = state.sign.trim();
      var adds = state.addons.map(function (id) { var b = $('[data-addon="' + id + '"]'); return b ? b.dataset.title : ''; }).filter(Boolean);
      if (adds.length) base['Adicionales'] = adds.join(', ');
      var items = state.items.map(function (it) { return { id: it.variantId, quantity: it.qty, properties: base }; });
      var linked = { _ddc_pedido: pedido, _origen: 'catalogo_deslizable' };
      state.addons.forEach(function (id) { items.push({ id: id, quantity: 1, properties: Object.assign({ _ddc_tipo: 'adicional' }, linked) }); });
      items.push({ id: +z.dataset.variant, quantity: 1, properties: Object.assign({ _ddc_tipo: 'domicilio' }, linked) });
      if (s.dataset.special) items.push({ id: +s.dataset.special, quantity: 1, properties: Object.assign({ _ddc_tipo: 'horario' }, linked) });

      // si ya había intentado pagar antes, quitamos esas líneas para no duplicar
      var cart = await (await fetch('/cart.js')).json();
      var updates = {};
      cart.items.forEach(function (l) { if (l.properties && l.properties._origen === 'catalogo_deslizable') updates[l.key] = 0; });
      if (Object.keys(updates).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });

      var r1 = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Order Due Date': state.date, 'Order Due Time': state.slot, 'Order Fulfillment Type': 'Local Delivery' } }) });
      if (!r1.ok) throw new Error('fecha');
      var r2 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!r2.ok) { var d = await r2.json().catch(function () { return {}; }); throw new Error(d.description || 'carrito'); }
      gtag('event', 'ddc_checkout_submit', { currency: 'COP', value: total() / 100, checkout_type: 'catalogo_deslizable' });
      var nm = splitName(state.to);
      var q = new URLSearchParams();
      q.append('checkout[email]', state.email.trim());
      q.append('checkout[shipping_address][first_name]', nm[0]);
      q.append('checkout[shipping_address][last_name]', nm[1]);
      q.append('checkout[shipping_address][address1]', state.address.trim());
      if (state.notes.trim()) q.append('checkout[shipping_address][address2]', state.notes.trim());
      q.append('checkout[shipping_address][city]', z.dataset.city || 'Bogotá');
      q.append('checkout[shipping_address][province]', z.dataset.province || 'DC');
      q.append('checkout[shipping_address][country]', 'CO');
      q.append('checkout[shipping_address][phone]', state.tophone);
      q.append('locale', 'es');
      state.step = 0; save();
      location.href = '/checkout?' + q.toString();
    } catch (e) {
      err.hidden = false; err.textContent = 'No pudimos preparar el pago (' + e.message + '). Puedes continuar por WhatsApp.';
      btn.disabled = false; btn.innerHTML = label;
    }
  });

  /* ---------- aviso corto ---------- */
  var toastEl = $('[data-ddc-cs-toast]'), tt;
  function hideToast() { clearTimeout(tt); toastEl.classList.remove('is-show'); toastEl.hidden = true; }
  function toast(t, linkText, ms) {
    toastEl.innerHTML = '<span>' + esc(t) + '</span>' + (linkText ? ' <button type="button" data-ddc-cs-checkout>' + esc(linkText) + '</button>' : '');
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-show'); });
    clearTimeout(tt);
    tt = setTimeout(hideToast, ms || 2600);
  }


  /* ---------- Leer: la página del catálogo en grande, se mueve con el dedo y se puede pellizcar ---------- */
  var zoom = $('[data-ddc-cs-zoom]'), zimg = $('[data-ddc-cs-zoomimg]'), zsc = $('[data-ddc-cs-zoomscroll]');
  function openZoom() {
    var img = slides[index].querySelector('.ddc-cs__page img');
    if (!img) return;
    var hi = img.dataset.hi;
    zimg.src = hi || img.currentSrc || img.src; zimg.alt = img.alt;
    zoom.hidden = false;
    requestAnimationFrame(function () {
      zoom.classList.add('is-open');
            // empieza centrado: la persona mueve con el dedo hacia donde quiere leer
      zsc.scrollTop = Math.max(0, (zimg.offsetHeight - zsc.clientHeight) * 0.2);
      zsc.scrollLeft = Math.max(0, (zimg.offsetWidth - zsc.clientWidth) * 0.75);
    });
    gtag('event', 'ddc_catalogo_leer', { pagina: current || '' });
  }
  function closeZoom() { zoom.classList.remove('is-open'); setTimeout(function () { zoom.hidden = true; zimg.removeAttribute('src'); }, 200); }
  zoomBtn.addEventListener('click', openZoom);
  $$('[data-ddc-cs-zoomclose]').forEach(function (b) { b.addEventListener('click', closeZoom); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zoom.hidden) closeZoom(); });
  // doble toque sobre una página simple = leer
  var lastTap = 0;
  slides.forEach(function (sl) {
    var fig = sl.querySelector('.ddc-cs__page'); if (!fig || sl.classList.contains('is-double')) return;
    fig.addEventListener('click', function () { var n = Date.now(); if (n - lastTap < 320) openZoom(); lastTap = n; });
  });


  /* ---------- Atrás siempre lleva a la portada de catálogos ----------
     Si la persona llegó directo (enlace compartido, Instagram), se deja la portada "debajo" en el historial:
     al darle atrás aterriza en la portada y nunca sale más allá desde el catálogo. */
  var hub = root.dataset.hub;
  if (hub) {
    var hubPath = hub.split('?')[0], hubView = (hub.split('view=')[1] || '');
    var fromHub = document.referrer && document.referrer.indexOf(location.host) >= 0 &&
      document.referrer.indexOf(hubPath) >= 0 && (!hubView || document.referrer.indexOf('view=' + hubView) >= 0);
    if (!fromHub && !(history.state && history.state.ddcCat)) {
      var here = location.href;
      history.replaceState({ ddcHubStub: 1 }, '', hub);
      history.pushState({ ddcCat: 1 }, '', here);
    } else if (!(history.state && history.state.ddcCat)) {
      history.replaceState({ ddcCat: 1, fromHub: 1 }, '', location.href);
    }
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.ddcHubStub) location.replace(hub);
    });
    // los enlaces "volver" usan el historial cuando la portada está justo atrás (sin recargar dos veces)
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ddc-cs-hub]'); if (!a) return;
      e.preventDefault();
      if (history.state && (history.state.ddcCat)) history.back(); else location.href = hub;
    });
  }

  /* ---------- arranque ---------- */
  measure();
  var hashI = location.hash ? idOf(location.hash.slice(1)) : -1;
  var savedSlide = (state.slides && state.slides[CAT]) || 0;
  var start = hashI >= 0 ? hashI : (restored && savedSlide < slides.length ? savedSlide : 0);
  go(start, false); setIndex(start);
  renderCount();
  if (restored && hashI < 0 && (savedSlide || state.items.length)) {
    if (state.items.length) toast('Tu pedido sigue aquí (' + count() + ')', 'Continuar', 5200);
    else toast('Seguimos donde ibas', null, 2200);
  }
})();
